/**
 * Query key utilities for profile hooks
 * Keys match backend controller method names
 */
export const profileKeys = {
  getProfile: () => ["profile", "getProfile"] as const,
  updateProfile: () => ["profile", "updateProfile"] as const,
  uploadAvatar: () => ["profile", "uploadAvatar"] as const,
  deleteAvatar: () => ["profile", "deleteAvatar"] as const,
} as const
